import { sendToApi } from 'api/client'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export type LimitKeys = 'source_materials' | 'seats' | 'ai_words' | 'plagiarism_checks' | 'brand_kits'
export type IntegrationType =
  | 'word_press'
  | 'x'
  | 'linkedin'
  | 'instagram'
  | 'facebook'
  | 'tiktok'
  | 'youtube'
  | 'mailchimp'

export type FeatureKeys = 'multiple_post_wizards'

export interface TierLimits {
  // Limits might not exist on legacy prices
  published_posts_limit?: string
  integrations_limit?: string
  plagiarism_checks_limit?: string
  ai_words_limit?: string
  seats_limit?: string
  source_materials_limit?: string
  brand_kits_limit?: string
  multiple_post_wizards?: 'disabled'
}

export interface CurrentTierUsage extends Record<LimitKeys, number> {
  source_materials: number
  brand_kits: number
  seats: number
  ai_words: number
  plagiarism_checks: number
  integrations: Record<ExternalIntegrationEnum, number>
  published_posts: Record<ExternalIntegrationEnum, number>
}

export interface CurrentTierResponse extends CurrentTierUsage {
  price_meta: TierLimits
}

export const getLimitFromString = (limitString: string | undefined) => {
  return limitString && limitString !== 'unlimited' ? parseInt(limitString) : Infinity
}

export const TierUsageClient = {
  getTierUsage: (workspaceId: number) => {
    return sendToApi<{ tier_usage: CurrentTierResponse }>(`/w/${workspaceId}/tier_usage`, {
      method: 'GET',
    })
  },
}
